export default "__VITE_ASSET__DclCqlUo__"